import Title from '@/components/ui/Title';
import { X } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function TitleLayout({
  title,
  subtitle,
  children,
  isEdit = false,
  description,
}: {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
  isEdit?: boolean;
  description?: string;
}) {
  if (isEdit) {
    return <div className="space-y-8">{children}</div>;
  }
  return (
    <div className="my-8 mx-6 space-y-8 ">
      <div className="flex justify-between items-center">
        <div>
          <h4 className="font-normal text-sm text-secondary">{subtitle}</h4>
          <Title level={1}>{title}</Title>
          <p className="text-sm font-normal text-tertiary">{description}</p>
        </div>

        {!isEdit && (
          <Link to="/webinars">
            <button>
              <X className="size-6 cursor-pointer text-black" />
            </button>
          </Link>
        )}
      </div>
      {children}
    </div>
  );
}
